import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { FictionalEnergyValueResponse } from "../../FictionalEnergyValueManager/FictionalEnergyValueManager";

function getSumColumn(): MRT_ColumnDef<FictionalEnergyValueResponse> {
  return {
    accessorKey: "sumKwh",
    header: "Summe (kWh)",
    enableEditing: false,
    Cell: ({ row }) => {
      const values = row.original;
      const sumKwh =
        (values.technischeNichtverfuegbarkeitKwh ?? 0) +
        (values.redispatchAbregelungKwh ?? 0) +
        (values.sonstigeAbschaltungOderDrosselungKwh ?? 0);

      return sumKwh.toLocaleString("de-DE", {
        maximumFractionDigits: 2
      });
    }
  };
}

export { getSumColumn };
